import { COLORS } from '@/theme';
import styled from 'styled-components';

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1.5rem;

  .stock-balances-table .ant-table-thead > tr > th .ant-input,
  .stock-balances-table .ant-table-thead > tr > th .ant-input-number,
  .stock-balances-table .ant-table-thead > tr > th .ant-select,
  .stock-balances-table .ant-table-thead > tr > th .ant-select-selector {
    font-size: 0.75rem;
  }

  /* Unify the background of every filter field (text input, select, number) */
  .stock-balances-table .ant-table-thead > tr > th .ant-input,
  .stock-balances-table .ant-table-thead > tr > th .ant-input-affix-wrapper,
  .stock-balances-table .ant-table-thead > tr > th .ant-input-number,
  .stock-balances-table .ant-table-thead > tr > th .ant-input-number-input,
  .stock-balances-table .ant-table-thead > tr > th .ant-select .ant-select-selector {
    background: ${COLORS.LIGHTEST_GRAY};
  }
`;

export const StyledBadge = styled.div<{ $isActive?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 8.5rem;
  height: 1.5rem;
  border-radius: 1rem;
  padding: 0.3rem;
  background: ${({ $isActive }) => ($isActive ? COLORS.GREEN : COLORS.NORMAL_GRAY)};
  color: ${COLORS.WHITE};
`;

export const StyledFilterRow = styled.tr`
  &&& {
    th {
      background-color: ${COLORS.LIGHTEST_GRAY};
      padding: 1rem 0.5rem;
      font-weight: normal;
    }

    th:last-child {
      border-right: none;
    }
  }
`;
